<div class="text-value">
    {{parsedText}}
</div>
